import { Observable, share, shareReplay, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ISearchFilterCommission,
  ICommissionInfo,
  IFilterModalCommission,
  IParametersCommission,
  ICommission,
  IProductValues,
  IProduct
} from './../../models/commission';
import { IGenericResult } from './../../models/generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiCommissionService {
  changeProductTabs: Subject<string> = new Subject<string>();
  getValueFormEvent: Subject<IProduct> = new Subject<IProduct>();
  listCommissionsEvent: Subject<boolean> = new Subject<boolean>();

  baseUrls: { [key: string]: string } = {
    /*commission: `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.commission}`*/
    commission: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceCommission}`
  };

  constructor(private _http: HttpClient) {}

  getCommission(commissionId: string): Observable<IGenericResult<ICommission>> {
    return this._http.get<IGenericResult<ICommission>>(
      `${this.baseUrls['commission']}/${commissionId}`
    );
  }

  getAllCommissions(
    searchFilter: ISearchFilterCommission
  ): Observable<IGenericResult<ICommissionInfo[]>> {
    return this._http.post<IGenericResult<ICommissionInfo[]>>(
      `${this.baseUrls['commission']}/list`,
      searchFilter
    );
  }

  getAllStatusBankAndPeriod(): Observable<
    IGenericResult<IFilterModalCommission>
  > {
    return this._http.get<IGenericResult<IFilterModalCommission>>(
      `${this.baseUrls['commission']}/FiltersComission`
    );
  }

  getParametersCommission(): Observable<IGenericResult<IParametersCommission>> {
    return this._http.get<IGenericResult<IParametersCommission>>(
      `${this.baseUrls['commission']}/ParamsComission`
    );
  }

  createCommission(
    commission: ICommission
  ): Observable<IGenericResult<ICommission>> {
    return this._http.post<IGenericResult<ICommission>>(
      `${this.baseUrls['commission']}/create`,
      commission
    );
  }

  updateCommission(
    commission: ICommission
  ): Observable<IGenericResult<ICommission>> {
    return this._http.put<IGenericResult<ICommission>>(
      `${this.baseUrls['commission']}/${commission.ComissionId}`,
      commission
    );
  }

  deleteCommission(commissionId: string): Observable<IGenericResult<unknown>> {
    return this._http.delete<IGenericResult<unknown>>(
      `${this.baseUrls['commission']}/${commissionId}`
    );
  }
}
